import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    state => state.userAccrual
)

export const selectIsUserAccrualModalOpen = createSelector(
    baseSelector,
    (state) => state.isUserAccrualModalOpen
)

export const selectOnAccrual = createSelector(
    baseSelector,
    (state) => state.onAccrual
)